<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import Vue from "vue";
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./resize";

const animationDuration = 6000;

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "500px",
    },
    chartTitle: {
      type: String,
      default: "",
    },
    legend: {
      type: Array,
      default: function () {
        return ["pageA", "pageB", "pageC"];
      },
    },
    seriesList: {
      type: Array,
      default: function () {
        return [
          {
            name: "pageA",
            type: "bar",
            stack: "vistors",
            barWidth: "60%",
            data: [79, 52, 200, 334, 330, 220],
            animationDuration,
          },
          {
            name: "pageB",
            type: "bar",
            stack: "vistors",
            barWidth: "60%",
            data: [80, 52, 200, 334, 390, 330, 220],
            animationDuration,
          },
          {
            name: "pageC",
            type: "bar",
            stack: "vistors",
            barWidth: "60%",
            data: [30, 52, 200, 334, 390, 330, 220],
            animationDuration,
          },
        ];
      },
    },
    xAxisList: {
      type: Array,
      default: function () {
        return ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      },
    },
    unit: {
      type: String,
      default: "",
    },
    magicTypeShow: {
      type: Boolean,
      default: false,
    },
    dataZoomShow: {
      type: Boolean,
      default: false,
    },
    restoreShow: {
      type: Boolean,
      default: false,
    },
    saveAsImageShow: {
      type: Boolean,
      default: false,
    },
    dataViewShow: {
      type: Boolean,
      default: false,
    },
    islegendbottom: {
      type: Boolean,
      default: true,
    },
    isdatazoom: {
      type: Boolean,
      default: false,
    },
    yAxisName: {
      type: String,
      default: "",
    },
    yAxisNameStyle: {
      type: Object,
      default: () => {},
    },
    titleposition: {
      type: String,
      default: "center",
    },
    yAxisprop: {
      type: Array,
      default: () => [],
    },
    rotateprop: {
      type: Number,
      default: 0,
    },
    axisLabelinterval: {
      type: Number,
      default: 0,
    },
    rightunit: {
      type: String,
      default: "",
    },
    cansortlegend: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chart: null,
      barOption: {
        color: [
          "#4B7CF3",
          // "#dd3ee5",
          "#bb5e5e",
          // "#12e78c",
          "#48c23a",
          "#fe8104",
          // "#01C2F9",
          "#6f8fce",
          "#F4CB29",
          "#FD9E06",
        ],
        // color: [
        //   "#00B050",
        //   "#7030A0",
        //   "#C0504D",
        //   "#31859C",
        //   "#87A0BE",
        //   "#FFD966",
        // ],
        title: {
          text: this.chartTitle,
          // subtext: "From ExcelHome",
          // sublink: 'http://e.weibo.com/1341556070/Aj1J2x5a5'
          // left: "left",
          left: this.titleposition,
        },
        toolbox: {
          show: true,
          feature: {
            // mark: { show: true },
            // dataView: { show: true, readOnly: false },
            dataView: { show: this.dataViewShow, readOnly: false },
            magicType: { show: this.magicTypeShow, type: ["line", "bar"] },
            dataZoom: { show: this.dataZoomShow },
            restore: { show: this.restoreShow },
            saveAsImage: { show: this.saveAsImageShow }, // 保存为图片
          },
        },
        tooltip: {
          confine: "overflow: visible",
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,0.6)",
          textStyle: {
            color: "white", //设置文字颜色
          },
          extraCssText: "overflow:visible",
          // trigger: "item",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
            lineStyle: {
              color: "#dfe6ec",
            },
            // show: true,
          },
          formatter: (params) => {
            // console.log(params);

            // return (
            //   params.name +
            //   "<br />" +
            //   "人数:" +
            //   params.value +
            //   "占比:" +
            //   ((params.value / tradenum) * 100).toFixed(2) +
            //   "%"
            // );
            // return null;
            // console.log(this.unit);
            let list = [`<span>${params[0].name}</span>`];
            let listItem = "";
            // if (this.unit == "%") {
            //   for (let i = 0; i < params.length; i++) {
            //     if (typeof params[i].data == Object) {
            //       list.push(
            //         `<span>${params[i].marker}  ${params[i].seriesName}: 百分比:${params[i].data["value"]}%   数值:${params[i].data["percent"]}  </span>`
            //       );
            //     } else {
            //       list.push(
            //         `<span>${params[i].marker}  ${params[i].seriesName}: 百分比:${params[i].value} % </span>`
            //       );
            //     }
            //   }
            // } else {
            //   for (let i = 0; i < params.length; i++) {
            //     list.push(
            //       `<span> ${params[i].marker} ${params[i].seriesName}: ${params[i].value}   </span>`
            //     );
            //   }
            // }

            for (let i = 0; i < params.length; i++) {
              if (params[i].seriesType == "line") {
                if (params[i].seriesName == "活跃新增比") {
                  list.push(`<span>${params[i].marker}  ${params[i].seriesName}: ${params[i].value}    </span>`);
                } else {
                  if (this.unit == "$") {
                    list.push(`<span>${params[i].marker}  ${params[i].seriesName}: $${params[i].value}    </span>`);
                  } else {
                    list.push(`<span>${params[i].marker}  ${params[i].seriesName}: ${params[i].value} %   </span>`);
                  }
                }
              } else if (params[i].seriesType == "bar") {
                if (this.rightunit == "$") {
                  list.push(`<span>${params[i].marker}  ${params[i].seriesName}: $${params[i].value}    </span>`);
                } else {
                  list.push(`<span>${params[i].marker}  ${params[i].seriesName}: ${params[i].value}  </span>`);
                }
              }
              // else {
              //   list.push(
              //     `<span>${params[i].marker}  ${params[i].seriesName}: ${params[i].value}    </span>`
              //   );
              // }
            }

            listItem = list.join("<br>");
            return '<div class="showBox">' + listItem + "</div>";
          },
        },
        legend: {
          data: this.legend,
          bottom: this.islegendbottom ? 0 : "auto",
          type: "scroll",
          width: "80%",
        },
        grid: {
          top: "12%",
          left: "8%",
          right: "8%",
          bottom: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisList,
            axisTick: {
              alignWithLabel: true,
              interval: 2,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#42546d",
              },
            },
            axisLabel: {
              interval: this.axisLabelinterval,
              rotate: this.rotateprop,
            },
            // axisLabel: this.axisLabelprop,
            // boundaryGap: ["20%", "40%"],
          },
        ],
        yAxis:
          this.yAxisprop.length > 0
            ? this.yAxisprop
            : [
                {
                  type: "value",
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    formatter: `{value}${this.unit}`,
                  },
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: "#42546d",
                    },
                  },
                  // name: this.yAxisName,
                  nameTextStyle: this.yAxisNameStyle,
                },
              ],
        // yAxis: this.yAxisprop,
        series: this.seriesList.filter((series) => this.legend.indexOf(series.name) >= 0),
        noDataLoadingOption: {
          text: "暂无数据", //没有数据时显示的文字
          effect: "whirling", //loading效果，此为气泡，还有'spin' | 'bar' | 'ring' | 'whirling' | 'dynamicLine' | 'bubble'
          effectOption: {
            backgroundColor: "rgba(50,50,50,0)", //loading的背景
          },
          textStyle: {
            //没有数据时显示的文字的样式
            fontSize: 32,
            fontWeight: "bold",
          },
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  // activated() {
  //   this.$nextTick(() => {
  //     this.initChart();
  //   });
  // },
  // deactivated() {
  //   if (!this.chart) {
  //     return;
  //   }
  //   this.chart.dispose();
  //   this.chart = null;
  // },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      let _this = this;
      let datazoomoption = [
        {
          type: "inside",
          start: 0,
          end: 100,
        },
        {
          start: 0,
          end: 10,
          handleSize: "80%",
          handleStyle: {
            color: "#fff",
            shadowBlur: 3,
            shadowColor: "rgba(0, 0, 0, 0.6)",
            shadowOffsetX: 2,
            shadowOffsetY: 2,
          },
        },
      ];
      if (this.dataZoomShow == true) {
        Vue.set(this.barOption, "dataZoom", datazoomoption);
      }
      this.chart.setOption(this.barOption);
      this.chart.on("click", function (params) {
        _this.$emit("handlerChartClick", params);
      });
      this.chart.on("legendselectchanged", (e) => {
        // console.log(e); // 如果不加off事件，就会叠加触发
        let arr = JSON.parse(JSON.stringify(this.yAxisprop));
        let arrseries = JSON.parse(JSON.stringify(this.seriesList));
        let arrnew = [];
        let arrnewseries = [];

        for (let i in e.selected) {
          if (e.selected[i] == true) {
            arrnew = arrnew.concat(
              arr.filter((item) => {
                return item.name == i;
              })
            );
            arrnewseries = arrnewseries.concat(
              arrseries.filter((item) => {
                return item.name == i;
              })
            );
          }
        }

        if (this.cansortlegend == true) {
          for (let i in e.selected) {
            e.selected[i] = true;
          }
          this.chart.setOption(this.barOption, true);
        }

        // let legend = arrnew.map((i) => i.name);
        // // console.log(arrseries);
        // // console.log(arrnewseries);
        // // console.log(arrnew);
        // // console.log(legend);
        // this.$nextTick(() => {
        //   // this.barOption.legend.data = legend;
        //   // this.$emit("onlengendchangey", arrnew, arrnewseries, legend);
        //   // this.barOption.yAxis = arrnew;
        //   // this.barOption.series = arrnewseries;
        //   // this.chart.setOption(this.barOption, true);
        // });
      });
    },
    reflashChart() {
      this.$nextTick(() => {
        this.chart.clear();
        this.barOption.xAxis[0].data = this.xAxisList;
        this.barOption.legend.data = this.legend;
        this.barOption.series = this.seriesList.filter((series) => this.legend.indexOf(series.name) >= 0);
        this.chart.setOption(this.barOption, true);
        this.resize();
      });
    },
    loading() {
      this.chart &&
        this.chart.showLoading({
          text: "loading",
          color: "#c23531",
          textColor: "#000",
          maskColor: "rgba(255, 255, 255, 0.2)",
          zlevel: 0,
        });
    },
  },
  watch: {
    chartTitle: function () {
      // console.log(newVal);
      // this.chart.clear();
      this.chart.clear();
      this.barOption.title.text = this.chartTitle;
      this.chart.setOption(this.barOption, true);
    },
    legend: function (newVal) {
      // console.log(newVal);
      this.chart.clear();
      this.barOption.legend.data = newVal;
      this.$nextTick(() => {
        this.barOption.series = this.seriesList.filter((series) => newVal.indexOf(series.name) >= 0);
      });
      this.chart.setOption(this.barOption, true);
    },
    xAxisList: function () {
      this.chart.clear();
      this.barOption.xAxis[0].data = this.xAxisList;
      this.barOption.legend.data = this.legend;
      this.barOption.series = this.seriesList;
      this.chart.setOption(this.barOption, true);
    },
    seriesList: function () {
      this.chart.clear();
      this.barOption.xAxis[0].data = this.xAxisList;
      this.barOption.legend.data = this.legend;
      this.barOption.series = this.seriesList;
      // this.barOption.yAxis[0].axisLabel.formatter = `{value}${this.unit}`;
      // this.barOption.yAxis[0].name = this.yAxisName;
      this.barOption.yAxis = this.yAxisprop;
      this.chart.setOption(this.barOption, true);
    },
    // magicTypeShow: function (n, o) {
    //   console(n, o, "4444444444444444444444444444444");
    //   this.barOption.toolbox.feature.magicTypeShow.show = n;
    //   this.chart.setOption(this.barOption, true);
    // },
    // yAxis: function () {
    //   this.barOption.xAxis[0].data = this.xAxisList;
    //   this.barOption.legend.data = this.legend;
    //   this.barOption.series = this.seriesList;
    //   this.barOption.yAxis[0].axisLabel.formatter = `{value}${this.unit}`;
    //   this.barOption.yAxis[0].name = this.yAxisName;
    //   // this.barOption.yAxis = this.yAxis;
    //   this.barOption.yAxis = this.yAxisprop;
    //   this.chart.setOption(this.barOption, true);
    // },
    rotateprop: function () {
      this.chart.clear();
      this.barOption.xAxis[0].axisLabel.rotate = this.rotateprop;

      this.chart.setOption(this.barOption, true);
    },
    yAxisprop: {
      handler(n, o) {
        if (n !== o) {
          this.chart.clear();
          this.barOption.yAxis = n;
          this.chart.setOption(this.barOption, true);
        }
      },
      deep: true, //对象内部属性的监听，关键。
    },
    axisLabelinterval() {
      this.chart.clear();
      this.barOption.xAxis[0].axisLabel.interval = this.axisLabelinterval;

      this.chart.setOption(this.barOption, true);
    },
  },
};
</script>
